import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { Doctor } from "src/app/shared/models/doctor";
import { DoctorDetails } from "src/app/shared/models/doctorDetails";
import { UserAccount } from "src/app/shared/models/user-account";

@Component({
  selector: "app-reject-doctor",
  templateUrl: "./reject-doctor.component.html",
  styleUrls: ["./reject-doctor.component.sass"],
})
export class RejectDoctorComponent implements OnInit {
  action: any;
  dialogTitle: any;
  doctor: any;
  rejectDoctorForm: FormGroup;
  doctorDetails: DoctorDetails;
  currentUser: UserAccount;
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RejectDoctorComponent>,
    private pharmcistService: PharmcistService,
    private spinner: NgxSpinnerService
  ) {
    this.doctor = new Doctor();
    this.doctorDetails = new DoctorDetails();
    this.action = data.action;
    this.doctorDetails = data.doctor;
    if (data.action === "reject") {
      this.dialogTitle =
        data.doctor.userAccount.FirstName +
        " " +
        data.doctor.userAccount.LastName;
    }
    this.rejectDoctorForm = this.formBuilder.group({
      comment: ["", [Validators.required, Validators.maxLength(100)]],
    });
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  ngOnInit(): void {}

  get f() {
    return this.rejectDoctorForm.controls;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  RejectDoctor() {
    if (this.rejectDoctorForm.valid) {
      this.spinner.show();
      this.doctorDetails.doctor.IsApproved = "REJECTED";
      this.doctorDetails.doctor.CreatedById = this.currentUser.Id;
      this.doctorDetails.doctor.Description = this.rejectDoctorForm.get(
        "comment"
      ).value;
      var doctorDetails = {
        doctorDetails: this.doctorDetails.doctor,
      };
      this.pharmcistService.ChangeDoctorStatus(doctorDetails).subscribe({
        next: (resp: any) => {
          if (!resp.hasErrors) {
            this.dialogRef.close(1);
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
    }
  }

  onSubmit() {}
}
